import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  schedule: [],
  InstructorInClassBatchesDetails: [],
  loading: true,
  error: false,
  InstituteSchedule: [],
};

export const ScheduleReducer = createReducer(initialState, (builder) => {
  builder.addCase("GetStudentScheduleRequest", (state) => {
    state.loading = true;
  });

  builder.addCase("GetStudentScheduleSuccess", (state, action) => {
    state.loading = false;
    state.error = false;
    state.schedule = action.payload;
  });

  builder.addCase("GetStudentScheduleFailure", (state, action) => {
    state.loading = false;
    state.error = action.payload;
  });

  builder.addCase("GetTeacherScheduleRequest", (state) => {
    state.loading = true;
  });

  builder.addCase("GetTeacherScheduleSuccess", (state, action) => {
    state.loading = false;
    state.error = false;

    state.schedule = action.payload;
  });

  builder.addCase("GetTeacherScheduleFailure", (state, action) => {
    state.loading = false;
    state.error = action.payload;
  });

  builder.addCase("GetInstituteAllLessonsRequest", (state) => {
    state.loading = true;
  });

  builder.addCase("GetInstituteAllLessonsSuccess", (state, action) => {
    state.loading = false;
    state.error = false;
    state.InstituteSchedule = action.payload;
  });

  builder.addCase("GetInstituteAllLessonsFailure", (state, action) => {
    state.loading = false;
    state.error = action.payload;
  });

  builder.addCase("GetInstituteStudentsScheduleRequest", (state) => {
    state.loading = true;
  });

  builder.addCase("GetInstituteStudentsScheduleSuccess", (state, action) => {
    state.loading = false;
    state.error = false;

    state.schedule = action.payload;
  });

  builder.addCase("GetInstituteStudentsScheduleFailure", (state, action) => {
    state.loading = false;
    state.error = action.payload;
  });

  builder.addCase("UpdateScheduleRequest", (state) => {
    state.loading = true;
  });

  builder.addCase("UpdateScheduleSuccess", (state, action) => {
    state.loading = false;
    state.error = false;
    state.schedule = action.payload;
  });

  builder.addCase("UpdateScheduleFailure", (state, action) => {
    state.loading = false;
    state.error = action.payload;
  });

  builder.addCase("UpdateSysDisabledStatusRequest", (state) => {
    state.loading = true;
  });

  builder.addCase("UpdateSysDisabledStatusSuccess", (state, action) => {
    state.loading = false;
    state.error = false;
  });

  builder.addCase("UpdateSysDisabledStatusFailure", (state, action) => {
    state.loading = false;
    state.error = action.payload;
  });

  builder.addCase("SendClassReminderNotificationRequest", (state) => {
    state.loading = true;
  });

  builder.addCase("SendClassReminderNotificationSuccess", (state, action) => {
    state.loading = false;
    state.error = false;
  });

  builder.addCase("SendClassReminderNotificationFailure", (state, action) => {
    state.loading = false;
    state.error = action.payload;
  });

  builder.addCase("SendClassMissedEmailRequest", (state) => {
    state.loading = true;
  });
  
  builder.addCase("SendClassMissedEmailSuccess", (state, action) => {
    state.loading = false;
    state.error = false;
    state.schedule = action.payload;
  });
  
  builder.addCase("SendClassMissedEmailFailure", (state, action) => {
    state.loading = false;
    state.error = action.payload;
  });


  /////////////////////////////////////////////////////////////////

  builder.addCase("GetInstructorInClassBatchesDetailsRequest", (state) => {
    state.loading = true;
  });

  builder.addCase("GetInstructorInClassBatchesDetailsSuccess", (state, action) => {
    state.loading = false;
    state.error = false;
    state.InstructorInClassBatchesDetails = action.payload;
  });

  builder.addCase("GetInstructorInClassBatchesDetailsFailure", (state, action) => {
    state.loading = false;
    state.error = action.payload;
  });

});



